/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */
import FileSystemType from '../../../../core/file/system/file-system-type';

class FileSystemUnit {
  /** @inheritdoc */
  getName() {
    return 'internal';
  }

  /** @inheritdoc */
  getRoot() {}

  /** @inheritdoc */
  getInfo() {
    return new Promise((resolve) =>
      resolve({
        free: 0,
        id: 'internal',
        total: 0,
        used: 0
      })
    );
  }

  getType() {
    return FileSystemType.Internal;
  }
}

export default FileSystemUnit;
